export default "__VITE_ASSET__DZX87teb__"